;(function () {
  'use strict'

  angular
    .module('contrast.highcharts')
    .factory(
      'highchartsSeriesBuilderService',
      function highchartsSeriesBuilderServiceFactory(
        csTemplates,
        Highcharts,
        highchartsColorService,
        HIGHCHARTS_CHART_TYPES,
        HIGHCHARTS_COLORS,
        HIGHCHARTS_Z_INDEX
      ) {
        'ngInject'

        return {
          buildAreaSeries: buildAreaSeries,
          buildBackgroundAreaSeries: buildBackgroundAreaSeries,
          buildScatterSeries: buildScatterSeries,
          buildBackgroundScatterSeries: buildBackgroundScatterSeries,
          buildColumnSeries: buildColumnSeries,
          buildBackgroundColumnSeries: buildBackgroundColumnSeries,
          buildColorByPointColumnSeries: buildColorByPointColumnSeries,
          buildSinglePointScatterSeries: buildSinglePointScatterSeries,
          buildPlotLine: buildPlotLine,
          buildInvisiblePlotLine: buildInvisiblePlotLine,
          disableSeriesTrackingConfig: disableSeriesTrackingConfig
        }

        function buildAreaSeries(
          id,
          data,
          tooltipMessage,
          color,
          zIndex,
          initialGradient,
          finalGradient,
          rawConfig
        ) {
          return {
            id: id,
            type: HIGHCHARTS_CHART_TYPES.AREA,
            zIndex: zIndex,
            color: color,
            colorDefault: color,
            colorDisabled: HIGHCHARTS_COLORS.DISABLED_SERIES,
            marker: {
              lineColor: null,
              lineWidth: 2,
              symbol: 'circle',
              fillColor: HIGHCHARTS_COLORS.WHITE,
              states: {
                hover: {
                  lineWidth: 0,
                  fillColor: color
                }
              }
            },
            fillColor: highchartsColorService.getGradientColor([
              {
                position: 0,
                color: color,
                opacity: initialGradient
              },
              {
                position: 1,
                color: color,
                opacity: finalGradient
              }
            ]),
            fillColorDisabled: highchartsColorService.getGradientColor([
              {
                position: 0,
                color: HIGHCHARTS_COLORS.DISABLED_SERIES,
                opacity: initialGradient
              },
              {
                position: 1,
                color: HIGHCHARTS_COLORS.DISABLED_SERIES,
                opacity: finalGradient
              }
            ]),

            tooltip: {
              valueSuffix: ''
            },
            data: data,

            rawConfig: rawConfig
          }
        }

        function buildBackgroundAreaSeries(
          id,
          data,
          tooltipMessage,
          color,
          colorHover,
          zIndex,
          initialOpacity,
          finalOpacity,
          config
        ) {
          var areaSeries = buildAreaSeries(
            id,
            data,
            tooltipMessage,
            color,
            zIndex,
            initialOpacity,
            finalOpacity,
            config
          )
          areaSeries.colorHover = colorHover
          areaSeries.fillColorHover = highchartsColorService.getGradientColor([
            {
              position: 0,
              color: colorHover,
              opacity: initialOpacity
            },
            {
              position: 1,
              color: colorHover,
              opacity: finalOpacity
            }
          ])

          areaSeries.marker = {
            enabled: false,
            states: {
              hover: {
                enabled: false
              }
            }
          }

          return areaSeries
        }

        function buildScatterSeries(
          id,
          data,
          tooltipMessage,
          color,
          zIndex,
          rawConfig
        ) {
          return {
            id: id,
            type: HIGHCHARTS_CHART_TYPES.SCATTER,
            zIndex: zIndex,
            color: color,
            colorDefault: color,
            colorDisabled: HIGHCHARTS_COLORS.DISABLED_SERIES,
            lineWidth: 2,
            marker: {
              lineColor: null,
              lineWidth: 2,
              symbol: 'circle',
              fillColor: HIGHCHARTS_COLORS.WHITE,
              states: {
                hover: {
                  lineWidth: 0,
                  fillColor: color
                }
              }
            },
            stickyTracking: false,

            data: data,

            rawConfig: rawConfig
          }
        }

        function buildBackgroundScatterSeries(
          id,
          data,
          tooltipMessage,
          color,
          colorHover,
          zIndex
        ) {
          var scatterSeries = buildScatterSeries(
            id,
            data,
            tooltipMessage,
            color,
            zIndex
          )
          scatterSeries.colorHover = colorHover
          return scatterSeries
        }

        function buildColumnSeries(
          id,
          data,
          tooltipMessage,
          color,
          zIndex,
          initialGradient,
          finalGradient,
          config
        ) {
          _enableColumnWithRoundedCorners()

          return {
            id: id,
            type: HIGHCHARTS_CHART_TYPES.COLUMN,
            zIndex: zIndex,
            shadow: false,
            color: highchartsColorService.getGradientColor([
              {
                position: 0,
                color: color,
                opacity: initialGradient
              },
              {
                position: 1,
                color: color,
                opacity: finalGradient
              }
            ]),
            colorDefault: highchartsColorService.getGradientColor([
              {
                position: 0,
                color: color,
                opacity: initialGradient
              },
              {
                position: 1,
                color: color,
                opacity: finalGradient
              }
            ]),
            colorDisabled: highchartsColorService.getGradientColor([
              {
                position: 0,
                color: HIGHCHARTS_COLORS.DISABLED_SERIES,
                opacity: initialGradient
              },
              {
                position: 1,
                color: HIGHCHARTS_COLORS.DISABLED_SERIES,
                opacity: finalGradient
              }
            ]),
            borderRadiusTopLeft: '50%',
            borderRadiusTopRight: '50%',
            borderWidth: 0,
            pointWidth: 10,
            pointPlacement: 'on',

            tooltip: {
              valueSuffix: ''
            },
            data: data,

            rawConfig: config
          }
        }

        function buildBackgroundColumnSeries(
          id,
          data,
          tooltipMessage,
          color,
          colorHover,
          zIndex,
          initialGradient,
          finalGradient,
          config
        ) {
          var columnSeries = buildColumnSeries(
            id,
            data,
            tooltipMessage,
            color,
            zIndex,
            initialGradient,
            finalGradient,
            config
          )

          columnSeries.colorHover = highchartsColorService.getGradientColor([
            {
              position: 0,
              color: colorHover,
              opacity: initialGradient
            },
            {
              position: 1,
              color: colorHover,
              opacity: finalGradient
            }
          ])

          return columnSeries
        }

        function buildColorByPointColumnSeries(
          id,
          data,
          tooltipMessage,
          color,
          zIndex,
          initialGradient,
          finalGradient,
          maxYAxisValue,
          config
        ) {
          var columnSeries = buildColumnSeries(
            id,
            data,
            tooltipMessage,
            color,
            zIndex,
            initialGradient,
            finalGradient,
            config
          )

          columnSeries.colorByPoint = true

          columnSeries.colors = data.map(function (element) {
            if (element.y === maxYAxisValue) {
              return highchartsColorService.getGradientColor([
                {
                  position: 0,
                  color: HIGHCHARTS_COLORS.HIGHEST_Y_VALUE,
                  opacity: initialGradient
                },
                {
                  position: 0.3,
                  color: color,
                  opacity: initialGradient
                },
                {
                  position: 1,
                  color: color,
                  opacity: finalGradient
                }
              ])
            } else {
              return highchartsColorService.getGradientColor([
                {
                  position: 0,
                  color: color,
                  opacity: initialGradient
                },
                {
                  position: 1,
                  color: color,
                  opacity: finalGradient
                }
              ])
            }
          })

          columnSeries.colorsDefault = columnSeries.colors.slice()

          columnSeries.colorsDisabled = data.map(function () {
            return highchartsColorService.getGradientColor([
              {
                position: 0,
                color: HIGHCHARTS_COLORS.DISABLED_SERIES,
                opacity: initialGradient
              },
              {
                position: 1,
                color: HIGHCHARTS_COLORS.DISABLED_SERIES,
                opacity: finalGradient
              }
            ])
          })

          return columnSeries
        }

        function buildSinglePointScatterSeries(xPoint, yPoint) {
          return {
            type: HIGHCHARTS_CHART_TYPES.SCATTER,
            marker: {
              enabled: false
            },
            enableMouseTracking: false,

            data: [[xPoint, yPoint]]
          }
        }

        function buildPlotLine(
          yValue,
          color,
          tooltipMessage,
          plotLineLabelTpl
        ) {
          return {
            color: color,
            width: 1,
            dashStyle: 'dash',
            label: {
              useHTML: false,
              align: 'left',
              textAlign: 'right',
              x: -2,
              y: 4,
              text: csTemplates.interpolate(plotLineLabelTpl, {
                yValue: yValue
              }),
              style: {
                color: HIGHCHARTS_COLORS.PLOT_LINE_TOOLTIP,
                fontWeight: 'bold'
              }
            },
            zIndex: HIGHCHARTS_Z_INDEX.TOP,

            value: yValue
          }
        }

        function buildInvisiblePlotLine(
          yValue,
          color,
          tooltipMessage,
          plotLineLabelTpl
        ) {
          return {
            color: color,
            width: 1,
            dashStyle: 'dash',
            label: {
              useHTML: true,
              align: 'left',
              textAlign: 'right',
              x: 0,
              text: csTemplates.interpolate(plotLineLabelTpl, {
                yValue: yValue,
                labelText: tooltipMessage
              })
            },
            zIndex: HIGHCHARTS_Z_INDEX.TOP,

            value: yValue
          }
        }

        /**
         * @description Disable the mouse tracking for a specific series. This includes point tooltips and click events on graphs and points.
         * @param {Highcharts Series Object} series
         */
        function disableSeriesTrackingConfig(series) {
          angular.extend(series, {
            lineWidth: series.type === 'scatter' ? 1 : 0,
            enableMouseTracking: false,
            marker: {
              enabled: false,
              states: {
                hover: {
                  enabled: false
                }
              }
            }
          })
        }

        /* This plugin adds options for setting rounded corners on bar and column charts.
         * The plugin adds four options to the column series object
         * borderRadiusTopLeft
         * borderRadiusTopRight
         * borderRadiusBottomLeft
         * borderRadiusBottomRight
         * If the options are given as numbers, they are interpreted as pixels. If given as percentage strings, they are percentages of the column width.
         * reference: https://github.com/highcharts/rounded-corners
         * */
        function _enableColumnWithRoundedCorners() {
          var rel = Highcharts.relativeLength

          Highcharts.wrap(
            Highcharts.seriesTypes.column.prototype,
            'translate',
            function (proceed) {
              var options = this.options,
                topMargin = options.topMargin || 0,
                bottomMargin = options.bottomMargin || 0

              proceed.call(this)

              this.points.forEach(function (point) {
                var shapeArgs = point.shapeArgs,
                  w = shapeArgs.width,
                  h = shapeArgs.height,
                  x = shapeArgs.x,
                  y = shapeArgs.y

                // Get the radius
                var rTopLeft = rel(options.borderRadiusTopLeft || 0, w),
                  rTopRight = rel(options.borderRadiusTopRight || 0, w),
                  rBottomRight = rel(options.borderRadiusBottomRight || 0, w),
                  rBottomLeft = rel(options.borderRadiusBottomLeft || 0, w)

                if (rTopLeft || rTopRight || rBottomRight || rBottomLeft) {
                  var maxR = Math.min(w, h) / 2

                  if (rTopLeft > maxR) {
                    rTopLeft = maxR
                  }

                  if (rTopRight > maxR) {
                    rTopRight = maxR
                  }

                  if (rBottomRight > maxR) {
                    rBottomRight = maxR
                  }

                  if (rBottomLeft > maxR) {
                    rBottomLeft = maxR
                  }

                  // Preserve the box for data labels
                  point.dlBox = point.shapeArgs

                  point.shapeType = 'path'
                  point.shapeArgs = {
                    d: [
                      'M',
                      x + rTopLeft,
                      y + topMargin,
                      // top side
                      'L',
                      x + w - rTopRight,
                      y + topMargin,
                      // top right corner
                      'C',
                      x + w - rTopRight / 2,
                      y,
                      x + w,
                      y + rTopRight / 2,
                      x + w,
                      y + rTopRight,
                      // right side
                      'L',
                      x + w,
                      y + h - rBottomRight,
                      // bottom right corner
                      'C',
                      x + w,
                      y + h - rBottomRight / 2,
                      x + w - rBottomRight / 2,
                      y + h,
                      x + w - rBottomRight,
                      y + h + bottomMargin,
                      // bottom side
                      'L',
                      x + rBottomLeft,
                      y + h + bottomMargin,
                      // bottom left corner
                      'C',
                      x + rBottomLeft / 2,
                      y + h,
                      x,
                      y + h - rBottomLeft / 2,
                      x,
                      y + h - rBottomLeft,
                      // left side
                      'L',
                      x,
                      y + rTopLeft,
                      // top left corner
                      'C',
                      x,
                      y + rTopLeft / 2,
                      x + rTopLeft / 2,
                      y,
                      x + rTopLeft,
                      y,
                      'Z'
                    ]
                  }
                }
              })
            }
          )
        }
      }
    )
})()
